import { AuthGuard, UserRole } from "@allbesmart/web-app-keycloak-auth";
import { Routes } from "@angular/router";
import { BackofficeRootComponent } from "./backoffice-root/backoffice-root.component";
import { OperationsPageComponent } from "./components/operations/operations-page/operations-page.component";
import { AvailableRoutes } from "./enums/available-routes";
import { SalesGuard } from "./guards/sales.guard";
import { ClientsListPageComponent } from "./pages/clients-list-page/clients-list-page.component";
import { GnbCustomConfigurationPageComponent } from "./pages/gnb-custom-configuration-page/gnb-custom-configuration-page.component";
import { GnbDefaultConfigurationPageComponent } from "./pages/gnb-default-configuration-page/gnb-default-configuration-page.component";
import { KcUnauthorizedPageComponent } from "./pages/kc-unauthorized-page/kc-unauthorized-page.component";
import { LicensesPageComponent } from "./pages/licenses-page/licenses-page.component";
import { NewDeploymentPageComponent } from "./pages/new-deployment-page/new-deployment-page.component";
import { OrdersPageComponent } from "./pages/orders-page/orders-page.component";
import { ReleaseCreatePageComponent } from "./pages/release-create-page/release-create-page.component";
import { ReleasesPageComponent } from "./pages/releases-page/releases-page.component";
import { UpdateDeploymentPageComponent } from "./pages/update-deployment-page/update-deployment-page.component";
import { UserCreatePageComponent } from "./pages/user-create-page/user-create-page.component";
import { UsersPageComponent } from "./pages/users-page/users-page.component";

export const routes: Routes = [
  {
    path: "",
    canActivate: [AuthGuard.isAccessAllowed, SalesGuard.goToLicenses],
    component: BackofficeRootComponent,
    children: [
      { path: "", redirectTo: AvailableRoutes.ADMIN, pathMatch: "full" },
      {
        path: AvailableRoutes.ADMIN,
        canActivate: [AuthGuard.isAccessAllowed, SalesGuard.goToLicenses],
        data: { roles: [UserRole.ADMIN_PAGE] },
        children: [
          {
            path: "",
            redirectTo: AvailableRoutes.DEPLOYMENTS,
            pathMatch: "full",
          },
          {
            path: AvailableRoutes.DEPLOYMENTS,
            children: [
              {
                path: "",
                canActivate: [
                  AuthGuard.isAccessAllowed,
                  SalesGuard.goToLicenses,
                ],
                component: ClientsListPageComponent,
              },
              {
                path: ":tenantId",
                canActivate: [
                  AuthGuard.isAccessAllowed,
                  SalesGuard.goToLicenses,
                ],
                data: { roles: [UserRole.ADMIN] },
                children: [
                  {
                    path: AvailableRoutes.UPDATE_DEPLOYMENT,
                    component: UpdateDeploymentPageComponent,
                  },
                  {
                    path: AvailableRoutes.GNB_CUSTOM_CONFIGURATION,
                    component: GnbCustomConfigurationPageComponent,
                  },
                ],
              },
            ],
          },
          {
            path: AvailableRoutes.NEW_DEPLOYMENT,
            component: NewDeploymentPageComponent,
            canActivate: [AuthGuard.isAccessAllowed, SalesGuard.goToLicenses],
            data: { roles: [UserRole.ADMIN] },
          },
          {
            path: AvailableRoutes.GNB_DEFAULT_CONFIGURATION,
            component: GnbDefaultConfigurationPageComponent,
            canActivate: [AuthGuard.isAccessAllowed, SalesGuard.goToLicenses],
            data: { roles: [UserRole.ADMIN] },
          },
        ],
      },
      {
        path: AvailableRoutes.LICENSES,
        component: LicensesPageComponent,
        canActivate: [AuthGuard.isAccessAllowed],
        data: { roles: [UserRole.SALES] },
      },
      {
        path: AvailableRoutes.STOCK,
        canActivate: [AuthGuard.isAccessAllowed, SalesGuard.goToLicenses],
        data: { roles: [UserRole.STOCK_MANAGEMENT_PAGE] },
        loadChildren: () =>
          import("./stock-management/stock-management.routes").then(
            (m) => m.routes
          ),
      },
      {
        path: AvailableRoutes.USERS,
        component: UsersPageComponent,
        canActivate: [AuthGuard.isAccessAllowed, SalesGuard.goToLicenses],
        data: { roles: [UserRole.ROOT] },
      },
      {
        path: AvailableRoutes.NEW_USER,
        component: UserCreatePageComponent,
        canActivate: [AuthGuard.isAccessAllowed, SalesGuard.goToLicenses],
        data: { roles: [UserRole.ROOT] },
      },
      {
        path: AvailableRoutes.RELEASES,
        component: ReleasesPageComponent,
        canActivate: [AuthGuard.isAccessAllowed, SalesGuard.goToLicenses],
        data: { roles: [UserRole.ROOT] },
      },
      {
        path: AvailableRoutes.NEW_RELEASE,
        component: ReleaseCreatePageComponent,
        canActivate: [AuthGuard.isAccessAllowed],
        data: { roles: [UserRole.ROOT] },
      },
      {
        path: AvailableRoutes.OPERATIONS,
        component: OperationsPageComponent,
        canActivate: [AuthGuard.isAccessAllowed],
        data: { roles: [UserRole.ROOT] },
      },
      {
        path: AvailableRoutes.ORDERS,
        component: OrdersPageComponent,
        canActivate: [AuthGuard.isAccessAllowed],
        data: { roles: [UserRole.ROOT] },
      },
    ],
  },
  {
    path: AvailableRoutes.UNAUTHORIZED,
    canActivate: [AuthGuard.isAccessAllowed],
    component: KcUnauthorizedPageComponent,
  },
];
